
export class CommandeBordereau {

    id: number;
    reference: string;
    banque: string;
    montant: number;
    modePayement: string;
    piecesJointes: string;
    dateCreation: any;
    commande: any;

    constructor() { }
}
